import type { ImagingWorklistLayout } from '../../utils/roleUtils';
import {
  type HubSpokeWorklistColumnKey,
  type ImagingColumnKey,
  IMAGING_COLUMNS_DEFAULT_VISIBILITY,
} from '../../constants/imagingWorklistColumns';

export type { ImagingColumnKey };

export function getDefaultImagingColumns(
  layout: ImagingWorklistLayout,
  showAssignedColumn: boolean,
  hubSpokeColumnKey: HubSpokeWorklistColumnKey | null
): Record<ImagingColumnKey, boolean> {
  return {
    ...IMAGING_COLUMNS_DEFAULT_VISIBILITY,
    assigned: layout === 'adminTech' && showAssignedColumn,
    assignedHubFacility: layout === 'adminTech' && hubSpokeColumnKey === 'assignedHubFacility',
    sourceFacility: layout === 'adminTech' && hubSpokeColumnKey === 'sourceFacility',
  };
}

const LS_KEY = 'ohif.imagingWorklist.columns.v3';
const LEGACY_LS_KEYS = ['ohif.imagingWorklist.columns.v2', 'ohif.imagingWorklist.columns.v1'];

function readStoredColumnVisibility(): Partial<Record<ImagingColumnKey, boolean>> | null {
  try {
    for (const key of [LS_KEY, ...LEGACY_LS_KEYS]) {
      const raw = localStorage.getItem(key);
      if (!raw) {
        continue;
      }
      return JSON.parse(raw) as Partial<Record<ImagingColumnKey, boolean>>;
    }
  } catch {
    return null;
  }
  return null;
}

export function loadImagingColumnVisibility(
  layout: ImagingWorklistLayout,
  showAssignedColumn: boolean,
  hubSpokeColumnKey: HubSpokeWorklistColumnKey | null
): Record<ImagingColumnKey, boolean> {
  const defaults = getDefaultImagingColumns(layout, showAssignedColumn, hubSpokeColumnKey);
  const parsed = readStoredColumnVisibility();
  if (!parsed) {
    return defaults;
  }
  const merged = { ...defaults, ...parsed, action: true };
  if (layout === 'radiologist' || !showAssignedColumn) {
    merged.assigned = false;
  }
  if (layout === 'radiologist' || !hubSpokeColumnKey) {
    merged.assignedHubFacility = false;
    merged.sourceFacility = false;
  } else if (hubSpokeColumnKey === 'assignedHubFacility') {
    merged.sourceFacility = false;
  } else if (hubSpokeColumnKey === 'sourceFacility') {
    merged.assignedHubFacility = false;
  }
  return merged;
}

export function persistImagingColumnVisibility(visibility: Record<ImagingColumnKey, boolean>) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(visibility));
  } catch {
    /* ignore */
  }
}
